import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import { Container } from '@mui/system';

const NotFound: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Container sx={{ textAlign: 'center' }}>
      <Typography sx={{ mt: 10 }} variant='h4'>
        {t('notFound.title')}
      </Typography>
    </Container>
  );
};

export default NotFound;
